/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

interface IArrowRightIcon extends ComponentPropsWithoutRef<'svg'> {
  fill?: string;
}

function ArrowRightIcon({ fill = '#1D1D1D', ...props }: IArrowRightIcon) {
  return (
    <svg width="27" height="25" viewBox="0 0 27 25" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2707 0.921696L26.016 12.6434L14.2707 24.3651L11.4451 21.5338L18.3494 14.6434H0.816284L0.816284 10.6434H18.3494L11.4451 3.75297L14.2707 0.921696Z"
        fill={fill}
      />
    </svg>
  );
}

export default memo(ArrowRightIcon);
